import React, { useMemo } from "react";

import {
  FeaturedProductCarousel as UIFeaturedProductCarousel,
  type FeaturedProductCarouselProps as UIFeaturedCarouselProps,
} from "@bared/ui";

import type { ProductCard as ProductCardType } from "types/product";

import { ProductCard } from "~/components/ProductCard";

import { AnalyticsViewItemListProvider } from "~/providers/AnalyticsViewItemListProvider";

type UISection = UIFeaturedCarouselProps["sections"][number];

export type FeaturedProductCarouselProps = Omit<
  UIFeaturedCarouselProps,
  "sections"
> & {
  sections: (Omit<UISection, "products"> & {
    products: ProductCardType[];
  })[];
};

export function FeaturedProductCarousel(props: FeaturedProductCarouselProps) {
  // Map the product card payloads from the server into actual product components.
  const mappedProps = useMemo(() => {
    return {
      ...props,
      sections: props.sections.map((section) => ({
        ...section,
        products: section.products.map((productCard, index) => (
          <ProductCard
            index={index}
            {...productCard}
            key={productCard.handle}
            sizes="(max-width: 768px) 100vw, 25vw"
          />
        )),
      })),
    } as UIFeaturedCarouselProps;
  }, [props]);

  return (
    <AnalyticsViewItemListProvider
      itemListId="featured-product-carousel"
      itemListName="Featured Product Carousel"
    >
      <UIFeaturedProductCarousel {...mappedProps} />
    </AnalyticsViewItemListProvider>
  );
}
